export default `float de(vec3 p){
    float radius = 1.;
    return length(p.xz)-radius; 
  }`